import classNames from 'classnames'
import css from '../../global-nav.scss'

import {
  healthPath,
  helloBabyPostPath,
  registryPath,
  registryHomePath,
  storePath,
} from 'lib/urls'

interface LoggedInSiteNavSectionProps {
  activeNavItem?: string
  trackClick: (eventCta: string) => void
  user: {
    currentRegistry: {
      urlSlug: string
      type?: string
    }
  }
}

const LoggedInSiteNavSection = ({
  activeNavItem,
  trackClick,
  user,
}: LoggedInSiteNavSectionProps) => {
  const helloBabyPost =
    user.currentRegistry.type === 'birthday' ? 'toddler' : null
  return (
    <>
      <li
        className={classNames(
          'hidden-xs',
          css.navLink,
          css.homeLink,
          activeNavItem === 'Home' && css.homeActive
        )}
      >
        {
          <a href={registryHomePath} onClick={() => trackClick('Home')}>
            Home
          </a>
        }
      </li>
      <li
        className={classNames(
          'hidden-xs',
          css.navLink,
          css.registryLink,
          activeNavItem === 'Registry' && css.registryActive
        )}
      >
        {
          <a
            href={registryPath(user.currentRegistry.urlSlug)}
            onClick={() => trackClick('Registry')}
          >
            Registry
          </a>
        }
      </li>
      <li
        className={classNames(
          'hidden-xs',
          css.navLink,
          css.storeLink,
          activeNavItem === 'Store' && css.storeActive
        )}
      >
        <a href={storePath} onClick={() => trackClick('Shop')}>
          Shop
        </a>
      </li>
      <li
        className={classNames(
          'hidden-xs',
          css.navLink,
          css.guidesLink,
          activeNavItem === 'Guides' && css.guidesActive
        )}
      >
        <a
          href={helloBabyPostPath(helloBabyPost)}
          onClick={() => trackClick('Guides')}
        >
          Guides
        </a>
      </li>
      <li className={classNames('hidden-xs', css.navLink)}>
        <a href={healthPath} onClick={() => trackClick('Health')}>
          Health
        </a>
      </li>
    </>
  )
}

export default LoggedInSiteNavSection
